import PlygonLogo from "assets/polygonlogo.svg";
import EthLogo from "assets/ethereum.svg";
import SVG from "react-inlinesvg";

import Icon from "@ant-design/icons";

export const PolygonIcon = (props: any) => (
  <Icon
    component={(iProps: any) => <SVG src={PlygonLogo} {...iProps} />}
    {...props}
  />
);

export const EthIcon = (props: any) => (
  <Icon
    component={(iProps: any) => <SVG src={EthLogo} {...iProps} />}
    {...props}
  />
);
